module.exports = __webpack_public_path__ + "static/img_4367-17532b1ebdb253f16c653e960a1b8c84.webp";